import React from "react";
import styled from "styled-components/native";

// Styled font to display warning (alarm) messages below the field (TODO: maybe revise the component name)
const Alarm = styled.Text`
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => props.theme.fontSize}px;
  color: ${props => props.theme.fieldAlarmColor};
`;

export default Alarm;
